import React, { useEffect, useRef, useState } from "react";

//Import Breadcrumb
import { Checkbox, Grid, Typography, } from "@mui/material";
import { connect, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Container } from "reactstrap";
import AppDialog from "../../../../components/Common/AppDialog";
import Breadcrumb from "../../../../components/Common/Breadcrumb";
import LoadingDialog from "../../../../components/Common/LoadingDialog";
import Notification from "../../../../components/Common/Notification";
import SearchBar from "../../../../components/Common/Searchbar";
import TablePageControl from "../../../../components/Common/TablePageControl";
import CustomIconButton from "../../../../components/Form/CustomIconButton";
import CustomSelect from "../../../../components/Form/CustomSelect";
import CustomSelectMultiple from "../../../../components/Form/CustomSelectMultiple";
import CustomTextField from "../../../../components/Form/CustomTextField";
import Helpers from "../../../../helpers/helpers";
import { bulkDeleteConfiguration, createConfiguration, deleteConfiguration, getConfigurationListing, getGeneral, resetConfigurationState, updateConfiguration } from "../../../../store/actions";
import "../../setting.css";
import Table from "./Table";
import CustomButton from "../../../../components/Form/CustomButton";

const ProductConfigurationSetting = ({ title, categoryListing, configurationListing, addConfiguration, editConfiguration, removeConfiguration, userPermission, bulkDelete }) => {
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(resetConfigurationState());
        dispatch(getGeneral())
    }, [])

    const [loading, setIsLoading] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [deleteIdx, setDeleteIdx] = useState();
    const [selectedRow, setSelectedRow] = useState([]);
    const [checkedAll, setCheckedAll] = useState(false);
    const [page, setPage] = useState("1");
    const [length, setLength] = useState("50");
    const [keyword, setSearch] = useState("");
    const [sort, setSorted] = useState("asc");
    const [sort_by, setSortBy] = useState();
    const error = '';
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });
    const [editConfigurationValue, setEditConfigurationValue] = useState()
    const [creatable, setCreatable] = useState(false);
    const [editable, setEditable] = useState(false);
    const [deletable, setDeletable] = useState(false);
    const [viewable, setViewable] = useState(false);
    const searchRef = useRef(keyword);

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-setting") && setCreatable(true);
            userPermission?.includes("edit-setting") && setEditable(true);
            userPermission?.includes("delete-setting") && setDeletable(true);
            userPermission?.includes("view-setting") && setViewable(true);
            !userPermission?.includes("view-setting") && navigate('/not-authorized');
        }
    }, [userPermission])

    useEffect(() => {
        searchRef.current = keyword;
    }, [keyword]);

    useEffect(() => {
        if (bulkDelete?.code === "success") {
            setIsLoading(false);
            setDeleteModalOpen(false);
            setNotification({
                open: true,
                msg: "Delete Successfully",
                type: "success",
            })
            dispatch(resetConfigurationState())
            setCheckedAll(false);
            setSelectedRow([]);
            dispatch(getGeneral());
            initData()
        } else if (bulkDelete?.code === "invalid_configuration") {
            setIsLoading(false);
            setDeleteModalOpen(false);
            setNotification({
                open: true,
                msg: "Invalid configuration",
                type: "error",
            })
            dispatch(resetConfigurationState())
            initData()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bulkDelete]);

    useEffect(() => {
        let conFigData = configurationListing?.data?.data || [];
        if (checkedAll && conFigData) {
            const productListingIDs = conFigData.map((item) => item.id);
            setSelectedRow(productListingIDs);
        } else if (!checkedAll && selectedRow.length === conFigData?.length) {
            // Only clear if all items were selected (meaning user clicked "uncheck all" header)
            setSelectedRow([]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkedAll, configurationListing?.data?.data]);

    const handleCheckboxChange = (e) => {
        setCheckedAll(false)
        let temp = []
        if (selectedRow && selectedRow?.length > 0 && selectedRow.includes(parseInt(e))) {
            temp = selectedRow.filter((x) => x !== parseInt(e)).map((y) => y)
            setSelectedRow(temp)
        } else {
            setSelectedRow([...selectedRow, parseInt(e)])
        }
    }

    const header = [
        {
            Header: "#",
            accessor: (cellProps) => {
                return (
                    <React.Fragment>
                        <Checkbox
                            checked={checkedAll ? checkedAll : selectedRow?.length > 0 ? selectedRow.includes(cellProps.id) : false}
                            sx={{
                                color: '#D0D0D0',
                                '&.Mui-checked': {
                                    color: "var(--bs-theme-color)",
                                },
                                paddingBlock: 0
                            }}
                            value={cellProps.id}
                            onChange={(event) => handleCheckboxChange(event.target.value, cellProps)} />
                    </React.Fragment>
                )
            },
        },
        {
            Header: "Configurations",
            columnID: 'name',
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        {
                            selectedRow === idx && creatable ?
                                <CustomTextField
                                    values={editConfigurationValue?.configuration_name}
                                    onChange={(e) => handleEditConfigurationChange('configuration_name', e)}
                                    placeholder={'e.g Processor'}
                                />
                                :
                                <div className="d-flex align-items-center" style={{ paddingRight: "5px" }}>{cellProps.descriptions[0].name}</div>
                        }

                    </React.Fragment>
                )
            },
            tooltipMessage: "Define the type of configuration, such as Processor or Memory, to group related options on the product page.",
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Icons",
            columnID: 'icon',
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        {
                            selectedRow === idx && creatable ?
                                <CustomSelect
                                    valueName={"icon"}
                                    labelName={"label"}
                                    icon={true}
                                    values={editConfigurationValue?.icon || '-1'}
                                    onChange={(e) => handleEditConfigurationChange('icon', e)}
                                    placeholder={'Select one'}
                                    data={Helpers?.icon || []}
                                /> :
                                <Typography><i className={`${cellProps?.descriptions?.[0]?.icon} p-2`}></i> {cellProps?.descriptions?.[0]?.icon}</Typography>

                        }
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
            minWidth: 250
        },
        {
            Header: "Category",
            // columnID: 'category_name',
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        {
                            selectedRow === idx && creatable ?
                                <CustomSelectMultiple
                                    values={editConfigurationValue?.category || '-1'}
                                    onChange={(e) => handleEditConfigurationChange('category', e)}
                                    placeholder={'Select one or more'}
                                    data={categoryListing || []}
                                /> :
                                cellProps?.categories?.length > 0 && cellProps?.categories.map((x, idx) => {
                                    return (x.category_description?.name + (idx < cellProps?.categories?.length - 1 ? ', ' : ''))
                                })
                        }
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
            minWidth: 250
        },
        {
            Header: "Allow multiple select",
            columnID: 'allow_multiple_select',
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        {
                            selectedRow === idx && creatable ?
                                <Checkbox checked={editConfigurationValue?.isMultipleSelect} sx={{
                                    color: '#D0D0D0',
                                    alignSelf: 'center',
                                    '&.Mui-checked': {
                                        color: "var(--bs-theme-color)",
                                    },
                                }} onChange={(event) => handleEditConfigurationChange('isMultipleSelect', event.target.checked)} /> :
                                <Checkbox
                                    checked={cellProps?.descriptions?.length > 0 && cellProps.descriptions[0].allow_multiple_select}
                                    sx={{
                                        color: '#D0D0D0',
                                        '&.Mui-checked': {
                                            color: "var(--bs-theme-color)",
                                        },
                                        paddingBlock: 0
                                    }}
                                    disabled={true}
                                    value={cellProps.id}
                                    onChange={(event) => ""} />
                        }
                    </React.Fragment>
                )
            },
            disableFilters: true,
            filterable: false,
        },
        // {
        //     Header: "With quantity selection?",
        //     columnID: 'allow_quantity_selection',
        //     accessor: (cellProps, idx) => {
        //         return (
        //             <React.Fragment>
        //                 {
        //                     selectedRow === idx ?
        //                         <Checkbox checked={editConfigurationValue?.withQuantitySelection} sx={{
        //                             color: '#D0D0D0',
        //                             alignSelf: 'center',
        //                             '&.Mui-checked': {
        //                                 color: "var(--bs-theme-color)",
        //                             },
        //                         }} onChange={(event) => handleEditConfigurationChange('withQuantitySelection', event.target.checked)} /> :
        //                         <Checkbox
        //                             checked={cellProps?.descriptions?.length > 0 && cellProps?.descriptions[0].allow_quantity_selection}
        //                             sx={{
        //                                 color: '#D0D0D0',
        //                                 '&.Mui-checked': {
        //                                     color: "var(--bs-theme-color)",
        //                                 },
        //                                 paddingBlock: 0
        //                             }}
        //                             disabled={true}
        //                             value={cellProps.id}
        //                             onChange={(event) => ""} />
        //                 }
        //             </React.Fragment>
        //         )
        //     },
        //     disableFilters: true,
        //     filterable: false,
        // },
        {
            Header: "Sort order",
            columnID: 'sort_order',
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        {
                            selectedRow === idx && creatable ?
                                <CustomTextField
                                    values={editConfigurationValue?.sort_order}
                                    onChange={(e) => handleEditConfigurationChange('sort_order', e)}
                                    placeholder={'0'}
                                /> :
                                cellProps?.sort_order
                        }
                    </React.Fragment>
                )
            },
            tooltipMessage: "Set the display order for configurations on the product page (lower numbers appear first).",
            disableFilters: true,
            filterable: false,
        },
        {
            Header: "Action",
            accessor: (cellProps, idx) => {
                return (
                    <React.Fragment>
                        {
                            selectedRow === idx && creatable ?
                                <>
                                    {viewable && <CustomIconButton
                                        iconName={'ri-check-line'}
                                        onClick={() => submitEditConfiguration()}
                                    />}
                                    {editable && <CustomIconButton
                                        iconName={'ri-close-line'}
                                        onClick={() => { setSelectedRow([]); setEditConfigurationValue() }}
                                    />}
                                </> :
                                <>
                                    {viewable && <Link to={`/settings-product-configurations/` + (cellProps.id)}>
                                        <CustomIconButton iconName={'ri-eye-line'} onClick={() => ''} />
                                    </Link>}
                                    {editable && <CustomIconButton
                                        iconName={'ri-pencil-line'}
                                        onClick={() => { handleSetEditConfiguration(idx, cellProps) }}
                                    />}
                                    {deletable && <CustomIconButton
                                        iconName={'ri-delete-bin-line'}
                                        onClick={() => { setDeleteIdx(cellProps?.id); setDeleteModalOpen(true) }}
                                        backgroundColor={'#44d62c'}
                                        color={'white'}
                                        borderStyle={"1px solid #44d62c"}
                                    />}
                                </>
                        }

                    </React.Fragment>
                )
            },
            minWidth: 150,
            position: 'sticky',
            disableFilters: true,
            filterable: false,
        }
    ]

    useEffect(() => {
        initData();
    }, [page, length, sort, sort_by])

    const initData = () => {
        let payload = {
            paginate: page,
            sort_order: sort,
            size: length,
            search: searchRef.current,
            sort: sort_by,
        }
        dispatch(getConfigurationListing(payload));
    }

    useEffect(() => {
        if (addConfiguration?.code === 'success') {
            setNotification({
                open: true,
                msg: 'Configuration added successfully',
                type: 'success'
            })
            dispatch(resetConfigurationState());
            initData();
        }
        setIsLoading(false);
    }, [addConfiguration])

    useEffect(() => {
        if (editConfiguration?.code === 'success') {
            setSelectedRow([]);
            setNotification({
                open: true,
                msg: 'Configuration edited successfully',
                type: 'success'
            })
            dispatch(resetConfigurationState());
            initData();
        }
        setIsLoading(false);
    }, [editConfiguration])

    useEffect(() => {
        if (removeConfiguration?.code === 'success') {
            setDeleteModalOpen(false);
            setDeleteIdx('');
            setNotification({
                open: true,
                msg: 'Configuration deleted successfully',
                type: 'success'
            })
            dispatch(resetConfigurationState());
            initData();
        }
        setIsLoading(false);
    }, [removeConfiguration])

    const handleEditConfigurationChange = (field, val) => {
        setEditConfigurationValue({ ...editConfigurationValue, [field]: val });
    }

    const handleSetEditConfiguration = (idx, cellProps) => {
        let selectedRowData = {
            configuration_name: cellProps.descriptions[0].name,
            category: cellProps.categories.map((x) => x.category_id),
            isMultipleSelect: cellProps.descriptions[0].allow_multiple_select,
            withQuantitySelection: cellProps.descriptions[0].allow_quantity_selection,
            sort_order: cellProps.sort_order,
            descriptions: cellProps?.descriptions,
            icon: cellProps?.descriptions?.[0]?.icon
        }
        setSelectedRow(idx);
        setEditConfigurationValue(selectedRowData);
    }

    const handleDeleteConfiguration = () => {
        if (selectedRow?.length > 0) {
            dispatch(bulkDeleteConfiguration({ ids: selectedRow }))

        } else {
            dispatch(deleteConfiguration({ id: deleteIdx }));
        }

        setIsLoading(true);
    }

    const submitNewConfiguration = (newConfiguration) => {
        if (newConfiguration?.sortOrder && newConfiguration?.configuration_name && newConfiguration?.category?.length > 0) {
            let payload = {
                sort_order: newConfiguration?.sortOrder || 0,
                status: 1,
                categories: [],
                descriptions: {
                    name: newConfiguration.configuration_name || '',
                    descriptions: null,
                    allow_multiple_select: newConfiguration.isMultipleSelect == 1 ? 1 : 0,
                    allow_quantity_selection: newConfiguration.withQuantitySelection == 1 ? 1 : 0,
                    icon: newConfiguration.icon_name || null,
                },
                items: []
            }
            if (newConfiguration?.category?.length > 0) {
                newConfiguration.category.map((x) => {
                    payload.categories.push({ category_id: x });
                })
            }
            dispatch(createConfiguration(payload));
        } else {
            setNotification({
                open: true,
                msg: 'Please fill all required fields',
                type: 'error'
            })
        }
    }

    const submitEditConfiguration = () => {
        let selectedData = configurationListing?.data?.data[selectedRow];
        let payload = {
            sort_order: editConfigurationValue?.sort_order || 0,
            status: selectedData.status || 1,
            categories: [],
            descriptions: {
                name: editConfigurationValue.configuration_name || '',
                descriptions: null,
                icon: editConfigurationValue.icon || null,
                allow_multiple_select: editConfigurationValue.isMultipleSelect == 1 ? 1 : 0,
                allow_quantity_selection: editConfigurationValue.withQuantitySelection == 1 ? 1 : 0,
            }
            ,
            items: configurationListing?.data?.items
        }
        if (editConfigurationValue?.category?.length > 0) {
            editConfigurationValue.category.map((x) => {
                payload.categories.push({ category_id: x });
            })
        }
        dispatch(updateConfiguration({ id: selectedData.id, data: payload }));
    }

    const handleSearch = (text) => {
        setSearch(text);
        setTimeout(() => {
            if (text === searchRef.current) {
                setPage("1");
                initData();
            }
        }, Helpers.searchInterval);
    }

    const customToolsBar = () => {
        return (
            <Grid container rowSpacing={2} mb={0} paddingBlock={1} paddingBottom={2}>
                <Grid item lg={5} sm={5} xs={12}>
                    <div className="d-flex align-items-center">
                        <SearchBar
                            value={keyword}
                            setValue={(e) => handleSearch(e)}
                        />
                    </div>
                </Grid>
                <Grid item lg={7} md={7} xs={7} sx={{ display: 'flex', justifyContent: { sm: 'end' } }}>
                    {deletable && selectedRow && selectedRow?.length > 0 && <CustomButton
                        title={<><i className="ri-delete-bin-line" style={{ marginRight: 5 }} />Delete</>}
                        press={() => setDeleteModalOpen(true)}
                        height={32}
                        borderRadius={15}
                        textColor={"white"}
                        backgroundColor={"#44d62c"}
                        borderStyle={"1px solid #44d62c"}
                    />}
                </Grid>

            </Grid>
        )
    }
    const deleteModal = () => {
        return (
            <AppDialog
                open={deleteModalOpen}
                close={() => { setDeleteIdx(); setDeleteModalOpen(false); setSelectedRow([]); setCheckedAll(false); }}
                titleIcon={'error'}
                title={'Delete Configuration'}
                positiveTitle={'Delete'}
                negativeTitle={'Cancel'}
                positivePress={() => handleDeleteConfiguration()}
                negativePress={() => { setDeleteIdx(); setDeleteModalOpen(false) }}
                positiveButtonStyle={{ backgroundColor: '#44d62c', color: 'white', border: '1px solid #44d62c' }}
                width={'40%'}
            >
                Are you sure you want to delete this configuration?
            </AppDialog>
        )
    }
    return (
        <React.Fragment>
            <div className="page-content">
                {deleteModal()}
                <LoadingDialog open={loading || !configurationListing?.data} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} />
                    <Breadcrumb
                        backRoute={'/settings'}
                        breadcrumbItems={[{ title: "Settings", link: "/settings" },
                        { title: title, link: "#" },
                        ]}
                    />
                    {customToolsBar()}
                    <Table
                        header={header}
                        data={configurationListing?.data?.data || []}
                        pageSize={configurationListing?.data?.data?.length || 10}
                        totalPage={configurationListing?.last_page || 1}
                        customToolsBar={true}
                        sort={sort}
                        setSorted={setSorted}
                        sort_by={sort_by}
                        setSortBy={setSortBy}
                        setCheckedAll={setCheckedAll}
                        checkedAll={checkedAll}
                        submitNewData={(data) => submitNewConfiguration(data)}
                        module={'configuration-list'}
                        categoryList={categoryListing || []}
                        submitted={addConfiguration?.code === 'success' || editConfiguration?.code === 'success'}
                        creatable={creatable}
                        viewable={viewable}
                        editable={editable}
                    />
                    <TablePageControl
                        length={length}
                        setLength={setLength}
                        page={page}
                        setPage={setPage}
                        totalPage={configurationListing?.data?.last_page || 1}
                    />
                </Container>
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ General, Configuration, Login }) {
    return {
        categoryListing: General.categories,
        configurationListing: Configuration.configurationListing,
        addConfiguration: Configuration.addConfiguration,
        editConfiguration: Configuration.updateConfiguration,
        removeConfiguration: Configuration.deleteConfiguration,
        bulkDelete: Configuration.bulkDeleteConfiguration,
        userPermission: Login.permissionArry,

    };
}

export default connect(mapStateToProps)(ProductConfigurationSetting);